<template>
  <div id="add-point-step">

    <step-template>
      <div slot="back" @click="close">&larr;</div>
      <div slot="default">
        <div class="font-bold mb-4">Tap on the map to show where in the world you are</div>
        <div>You can zoom in to get a bit more precise.</div>
      </div>
    </step-template>

  </div> 
</template>

<script>
import { mapGetters } from "vuex";
import StepTemplate from "./step-template.vue";

export default {
  components: {
    StepTemplate
  },
  computed: {
    ...mapGetters(["currentState", "newPoint"])
  },
  watch: {
    newPoint(newVal) {
      if (newVal) this.$store.commit("transition", { action: "ADDED" });
    }
  },
  methods: {
    close() {
      this.$store.commit("clearPinLatLng");
      this.$router.push({ name: "browse" });
    }
  }
};
</script>


// WEBPACK FOOTER //
// AddPointStep.vue?0a269798